// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"styles_loaderWrapper__D5sFL","root":"styles_root__y1Nth","description":"styles_description__qZct2","note":"styles_note__K7Vzo","actions":"styles_actions__RZPft"};